module.exports = __webpack_public_path__ + "img/space-introduce-3.77e5dff9.svg";